import { Directive } from '@angular/core';

@Directive({
  selector: '[modulecarre]',
  host:{
    'class': 'carre'
  }
})
export class CarreDirective {

  constructor() { }

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/utils/module/directive/carre.directive.ts